import { useContext, useState } from 'react';
import { CircularProgress } from '@mui/material';
import blackCross from '../../Assets/Images/black-cross.svg';
import ModalContext from '../../Store/ModalContext';
import MultipleAssessmentsContext from '../../Store/MultipleAssessmentsContext';
import { useNavigate } from 'react-router-dom';
import { preventWidow } from '../../utils/widowFix';
const CreateAssessmentPopup = ({ handleTranslate }) => {
  const modalCtx = useContext(ModalContext);
  const multipleCtx = useContext(MultipleAssessmentsContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const handleConfirm = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const hash = modalCtx?.modalData?.hashId;
      await multipleCtx.createNewOrganizationAssessment(hash);
      if (hash) {
        await multipleCtx.fetchDeploymentInfo(hash);
        window.location.href = `/dashboard/${hash}/overview?tab=parish`;
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsSubmitting(false);
      modalCtx.closeModal();
    }
  };

  const handleCancel = () => {
    modalCtx.closeModal();
    if (modalCtx.modalData.onCancel) {
      modalCtx.modalData.onCancel();
    }
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="title">{handleTranslate("Create New Assessment", "create-new-assessment")}</h2>
        <button className="close-button" onClick={modalCtx.closeModal}>
          <img src={blackCross} alt="close" />
        </button>
      </div>

      <div className="modal-content">
        <p className="confirmation-message">
          {handleTranslate(`Are you sure you want to close `, "confirmation-message1") }MW{multipleCtx?.deployments?.length===0 ? 1 : multipleCtx?.deployments?.length} {handleTranslate(`and open a new assessment?`, "confirmation-message2")}
        </p>

        <div className="button-container">
          <button className="cancel-button" onClick={handleCancel}>
            {handleTranslate("Cancel", "cancel")}
          </button>
          <button className="confirm-button" onClick={handleConfirm} disabled={isSubmitting}>
            {isSubmitting ? (
              <CircularProgress size={20} sx={{ color: 'white' }} />
            ) : (
              handleTranslate("Confirm", "confirm")
            )}
          </button>
        </div>
          <p className='note-message'>{preventWidow(handleTranslate(`Note: Once closed, all new results will go into the new assessment.`, "note-message"))}</p>
      </div>
    </>
  )
}
export default CreateAssessmentPopup;